export default __webpack_public_path__ + "static/ahmed-48593ef76aa93e3c76568b4bd784a05f.jpg";